<template>
  <div class="col-12">
    <div class="volex-banner volex-banner--desktop slider">
      <div v-for="slider in sliders" v-bind:key="slider.id">
        <a :href="slider.link" :target="slider.in_new_tab ? '_blank' : ''">
          <span>
            <img :src="sliderUrl + slider.id" alt="" />
          </span>
        </a>
      </div>
    </div>
    <button
      class="js-arrow-next slider-container__arrow slider-container__arrow--next"
      v-if="sliders.length >= 1"
    ></button>
    <button
      class="js-arrow-prev slider-container__arrow slider-container__arrow--prev"
      v-if="sliders.length >= 1"
    ></button>
  </div>
</template>

<script>
import Vue from "vue";
import { store } from "@/app/store";
import jQuery from "jquery";
import "slick-carousel/slick/slick.js";

export default {
  name: "SlickSlider",
  props: ["sliders"],
  methods: {
    getSliderSettings() {
      return {
        arrows: true,
        autoplay: true,
        dots: true,
        autoplaySpeed: 5000,
        infinite: true,
        prevArrow: ".js-arrow-prev",
        nextArrow: ".js-arrow-next",
      };
    },
  },
  data() {
    return {
      sliderUrl: process.env.NO_API_URL + "/slide/",
      slider: null,
      now: new Date(),
      deadline: new Date(2021, 5, 4),
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.slider = $(".slider");
      this.slider.slick(this.getSliderSettings());
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/app/home/slider/SlickSlider.vue